import { Box, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer/Footer';
import Nav from '../components/Nav/Nav';


import {
  useNavigate,
  useLocation
} from "react-router-dom";

const Layout = (props) => {


  const [page, setPage] = useState("");
  const location = useLocation();


  // useEffect(() => {
  //   const Pages = location.pathname.split("/");
  //   const activePage = Pages[Pages.length - 1];
  //   setPage(activePage);
  // }, [location.pathname])


  // console.log("imagetopdf-------------", page);

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh'
    }}>
      <Nav username="Scanner" page={page} breakPointsData={props.breakPointsData} />
      {/* <Toolbar /> */}
      <main> {props.children} </main>
      <Footer page={page} breakPointsData={props.breakPointsData} />
    </Box>
  )
}

export default Layout